module.exports = __webpack_public_path__ + "static/media/pa-superhero@3x.c66c10da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pa-superhero@3x.png
// module id = 1729
// module chunks = 0